export const voucherRefundContent = `
<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8" />
  <title>Comprobante de Devolución</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 40px;
      color: #333;
      font-size: 14px;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 20px;
    }
    .header-left p {
      margin: 2px 0;
      line-height: 1.4;
    }
    .header-left strong {
      font-size: 16px;
    }

    .header-left .bold {
      font-weight: bold;
    }

    .header-right {
      text-align: right;
      font-weight: bold;
      font-size: 14px;
    }
    .header-right p {
      margin: 2px 0;
    }
    .header-right strong {
      font-size: 18px;
    }
    .pre-estimado {
      margin-top: 20px;
    }
	
	.info-section {
		padding: 20px;
	}
	.gray-section {
		background-color: #f5f5f5;
	}
    .amount {
      text-align: center;
    }
    .amount p:first-child {
      font-size: 18px;
      margin: 0;
    }
    .amount h2 {
      font-size: 36px;
      color: #2d54af;
      margin: 5px 0;
      font-weight: bold;
    }
    .amount p {
      margin: 3px 0;
    }
    .section {

    }
    .section-title {
      font-weight: bold;
      color: #2d54af;
      margin-bottom: 15px;
    }
    .details-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px 20px;
      font-size: 14px;
    }
    .footer {
      font-size: 13px;
      color: #777;
    }
    .footer strong {
      font-weight: bold;
      color: #333;
    }

  .details-item .label {
    font-weight: normal;
    color: #555;
    margin: 0;
	border-bottom: 1px solid #ccc;
	padding-bottom: 10px;
  }
  
  .details-item .value {
    margin: 0px;
    font-weight: normal;
    line-height: 1.5;
  }
  
	.footer {
    margin-top: 20px;
    font-size: 13px;
  }

  .footer p {
    margin: 5px 0;
    color: #777; /* Texto de la nota final en gris */
  }

  .footer strong {
    font-weight: bold;
  }
  
.pre-estimado {
    margin-top: 40px; /* Espaciado adicional antes de “Estimado cliente” */
  }

  .gray-text { /* Para los textos "Informamos que..." y "Este comprobante..." */
    color: #777;
  }

  .sale-information-container {
	  grid-template-columns: repeat(3, 1fr);
  }
  
  .color-neutral-darker {
	color: #535353 !important;
  }
  </style>
</head>
<body>

  <div class="header">
    <div class="header-left color-neutral-darker">
      <p>Santiago, [format_date]</p>
      <p><strong>[merchant_name]</strong></p>
      <p class="bold">RUT [merchant_rut]</p>
      <p class="bold">[merchant_address]</p>
    </div>
    <div class="header-right">
      <p>N° de Operación</p>
      <p><strong>[operation_number]</strong></p>
    </div>
  </div>

  <div class="pre-estimado"></div>

  <p class="color-neutral-darker"><strong>Estimado cliente,</strong></p>
  <p class="gray-text">Informamos que su solicitud de devolución ha sido procesada exitosamente.<br>A continuación, se presentan los antecedentes:</p>

<section class="info-section gray-section" style="margin-top: 32px">
	<div class="amount">
		<p>Monto de Devolución</p>
		<h2>[amount]</h2>
		<p>Estado: [status]</p>
	</div>
	<div class="section">
	  <p class="section-title">Detalle de la devolución</p>
	  <div class="details-grid">
		<div class="details-item">
		  <p class="label">Fecha de solicitud</p>
		  <p class="value">[refund_request_date]</p>
		</div>
		<div class="details-item">
		  <p class="label">Tipo de transacción</p>
		  <p class="value">[transaction_type]</p>
		</div>
		<div class="details-item">
		  <p class="label">Últimos dígitos tarjeta</p>
		  <p class="value">[lastfourdigit]</p>
		</div>
		<div class="details-item">
		  <p class="label">Código de autorización</p>
		  <p class="value">[authorization_code]</p>
		</div>
	  </div>
	</div>  
</section>

<section class="info-section" style="padding-bottom: 0px; padding-top: 0px; margin-top: 24px;">
<div class="section">
  <p class="section-title">Información de la venta</p>
  <div class="details-grid sale-information-container">
    <div class="details-item">
      <p class="label">Nombre sucursal</p>
      <p class="value">[branch_name]</p>
    </div>
    <div class="details-item">
      <p class="label">Fecha de venta</p>
      <p class="value">[created_at]</p>
    </div>
    <div class="details-item">
      <p class="label">Monto de venta</p>
      <p class="value">[sale_amount]</p>
    </div>
    <div class="details-item">
      <p class="label">Código de autorización</p>
      <p class="value">[sale_authorization_code]</p>
    </div>
    <div class="details-item">
      <p class="label">Número de Orden</p>
      <p class="value">[refund_order_number]</p>
    </div>
  </div>
</section>
</div>  
  <div class="footer" style="margin-top: 32px">
    <p style="margin-bottom: 20px;">El plazo de la devolución puede extenderse hasta 5 días hábiles, dependiendo de la gestión del banco emisor.</p>
    <p>Atentamente,<br><strong class="color-neutral-darker">[merchant_name]</strong></p>
  </div>

</body>
</html>
`;